<template>
  <div class="page page-diary-index">
    <div class="header-info">
      <project-info :project="project"
                    :user="user"
                    type="diary"
      />
      <div class="camp-result"
           v-if="render.canEdit && render.showImpressionEntrance"
           @click="handleWorkDetail(projectId, userId)"
      >
        <div class="info">
          <ym-img class="icon"
                  src="https://res.youthmba.com/prod/phpteam/assets/img/icon/projectwork/pw_icon_achievements_highlight.png"
                  alt="图标"
          />
          <span>本次研学营收获</span>
        </div>
        <ym-img class="row-icon"
                src="https://res.youthmba.com/prod/phpteam/assets/img/icon/projectwork/pw_row_active.png"
                alt="图标"
        />
      </div>
    </div>
    <div class="diary-list">
      <div class="diary-item"
           v-for="(item, index) in list"
           :key="index"
      >
        <div class="diary-header">
          <div class="info">
            <div class="seq">{{ item.title }}</div>
            <div class="date">{{ item.date }}</div>
          </div>
          <div class="action"
               @click="handleDiaryDetail"
               v-if="render.canEdit && item.canEdit && item.diary && item.diary.content"
          >
            编辑
          </div>
        </div>
        <div v-if="item.diary">
          <div class="diary-content">{{ item.diary.content }}</div>
          <div class="diary-image-list">
            <image-list :list="item.diary.images"
                        :project-id="projectId"
                        :user-id="user.id"
                        page-type="diary"
            />
          </div>
        </div>
        <div class="diary-action diary-create-action"
             @click="handleDiaryDetail"
             v-else-if="item.canEdit"
        >
          马上创建
        </div>
        <div class="diary-action diary-close-action"
             v-else
        >
          即将开启
        </div>
      </div>
    </div>
    <div class="footer ym-mw-component-fixed-max">
      <div class="button edit"
           @click="handleDiaryDetail"
           v-if="render.canEdit"
      >
        编辑
      </div>
    </div>
    <qr-code-popup class="add-teacher-popup-container"
                   :show.sync="showSmallRoutinePopup"
                   title="识别小程序码进入小程序"
                   :src="qrCode"
                   :close-on-click-overlay="false"
    >
      <span class="hint">请在小程序中进行编辑</span>
    </qr-code-popup>
  </div>

</template>

<script>
  import ProjectInfo from '@/pages/ProjectWork/components/ProjectInfo';
  import { getDiaryIndexData } from '@/services/project-work';
  import ImageList from '@/pages/ProjectWork/components/ImageList';
  import QrCodePopup from '@/components/QrCodePopup';
  import { isAppWebView } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'ProjectDiary',
    metaInfo: {
      title: '日记详情',
    },
    components: {
      ProjectInfo,
      ImageList,
      QrCodePopup,
    },
    data() {
      return {
        projectId: 0,
        qrCode: '',
        showSmallRoutinePopup: false,
        userId: 0,
        list: [],
        project: {
          title: '',
          dayDesc: '',
          destination: '',
        },
        user: {
          name: '',
        },
        render: {
          pageTitle: '日记详情',
          showImpressionEntrance: false,
          canEdit: false,
        },
      };
    },
    methods: {
      compare(p) {
        return function (m, n) {
          return m[p] - n[p]; // 升序
        };
      },
      formatList(list) {
        list.map((item) => {
          if (item.diary) {
            item.diary.images.sort(this.compare('index'));
          }
          return item;
        });
        return list;
      },
      async fetchData(projectId, userId) {
        const data = await getDiaryIndexData(projectId, userId);

        this.projectId = Number(projectId);
        this.userId = Number(userId);
        this.qrCode = data.qrCode.src;
        this.list = this.formatList(data.list);
        this.project = data.project;
        this.user = data.user;
        this.render = data.render;
      },
      handleWorkDetail(projectId, userId) {
        this.$router.push({ name: 'ProjectWork', params: { projectId, userId } });
      },
      handleDiaryDetail() {
        if (isAppWebView()) {
          locationToAppWithRoute({
            name: 'AppQrCodeDetail',
            params: {
              qrCode: this.qrCode,
              hint: '识别小程序码进入小程序',
            },
          });
          return;
        }
        this.showSmallRoutinePopup = true;
      },
    },
    created() {
      const { projectId, userId } = this.$route.params;
      this.fetchData(projectId, userId);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-diary-index {
    height: 100%;
    padding: 0 @size-base;
    background: @color-white;
  }

  .header-info {
    padding-top: @size-large;
  }

  .camp-result {
    width: 100%;
    height: 100px;
    margin-bottom: @size-base;
    padding: 0 @size-base;
    box-sizing: border-box;
    background: #e9f7f7;
    border: @border-width-base @border-style-base @color-primary-aide;
    border-radius: @border-radius-normal;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: @font-size-medium;
    color: @color-text-base;
    .info {
      display: flex;
      align-items: center;
    }
    .icon {
      width: 40px;
      height: 40px;
      display: block;
      margin-right: 16px;
    }
    .row-icon {
      width: 16px;
      height: 28px;
      display: block;
    }
  }

  .diary-list {
    padding-left: 38px;
    padding-bottom: 140px;
    overflow: hidden;
    position: relative;
    &::before {
      position: absolute;
      height: 100%;
      width: 2px;
      content: '';
      background: #eee;
      top: 20px;
      left: 10px;
    }
  }

  .diary-item {
    margin-bottom: @size-large;
  }

  .diary-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info {
      display: flex;
      align-items: flex-end;
    }
    .seq {
      font-weight: @font-weight-bold;
      font-size: @font-size-large;
      color: @color-text-base;
      position: relative;
      &::after {
        position: absolute;
        content: '';
        background: linear-gradient(to right, #44ded8, #00bfd0);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        left: -38px;
        top: 20px;
      }
    }
    .date {
      margin-left: @size-base;
      padding-bottom: @size-extra-small / 2;
      font-size: @font-size-base;
      color: @color-text-light;
    }
    .action {
      width: 98px;
      height: 40px;
      border: @border-width-base @border-style-base @color-gray-light;
      border-radius: 4px;
      font-size: @font-size-small;
      color: @color-text-lighter;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .diary-content {
    margin: @size-base 0;
    font-size: @font-size-base;
    color: @color-text-base;
    line-height: 1.5;
  }

  .diary-action {
    width: 100%;
    height: 100px;
    margin-top: @size-small;
    margin-bottom: @size-large;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: @border-radius-normal;
    font-size: @font-size-medium;
  }

  .diary-create-action {
    background: @color-primary-lighter;
    color: @color-primary-aide;
  }

  .footer {
    position: fixed;
    padding: @size-base @size-medium;
    bottom: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: @color-white;
    .button {
      width: 100%;
      height: 94px;
      border-radius: 50px;
      font-size: @font-size-large;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      &.edit {
        border: @border-width-base @border-style-base @color-primary-aide;
        color: @color-primary-aide;
      }
    }
  }

  .diary-image-list {
    display: flex;
    justify-content: center;
  }

  .diary-close-action {
    background: @color-gray-lightest;
    color: @color-gray-light;
  }
</style>
